import { render } from "./PageTitleTopBrandTag.vue?vue&type=template&id=c3f6f222"
import script from "./PageTitleTopBrandTag.vue?vue&type=script&lang=js"
export * from "./PageTitleTopBrandTag.vue?vue&type=script&lang=js"

import "./PageTitleTopBrandTag.vue?vue&type=style&index=0&id=c3f6f222&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PageTitleTopBrandTag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c3f6f222"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c3f6f222', __exports__)) {
    api.reload('c3f6f222', __exports__)
  }
  
  module.hot.accept("./PageTitleTopBrandTag.vue?vue&type=template&id=c3f6f222", () => {
    api.rerender('c3f6f222', render)
  })

}


export default __exports__